<script setup lang="ts">
  import {
    Button,
    ButtonSize,
    ButtonVariant,
    Loader,
    LoaderSize,
    Tooltip,
  } from '@tundr/ds-components';
  import { useLocale } from '@tundr/i18n';
  import { computed } from 'vue';
  import type { TableActionIconProps } from './TableActionIcon.types';

  const emit = defineEmits<{
    click: [];
  }>();

  const props = defineProps<TableActionIconProps>();

  const { t } = useLocale('table');

  const showDisabledReason = computed(
    () => !!props.disabled && !!props.disabledReason,
  );

  const ariaLabel = computed(() =>
    showDisabledReason.value
      ? t('table.action_disabled_aria_label', {
          label: props.title,
          reason: props.disabledReason,
        })
      : props.title,
  );

  const buttonAttrs = computed(() => ({
    id: props.id,
    variant: ButtonVariant.Icon,
    size: ButtonSize.SM,
    isGhost: true,
    iconName: props.iconName,
    ariaLabel: ariaLabel.value,
    disabled: props.disabled,
    testId: props.testId,
    'data-test-id': props.testId,
  }));

  const onClick = () => {
    if (props.disabled) return;
    emit('click');
  };
</script>

<template>
  <Loader :size="LoaderSize.SM" :announced="false" v-if="loading" />
  <Button
    v-else-if="showDisabledReason"
    v-bind="buttonAttrs"
    :disabled-reason="disabledReason"
    @click.stop="onClick"
  />
  <Tooltip v-else :title="title">
    <Button v-bind="buttonAttrs" @click.stop="onClick" />
  </Tooltip>
</template>
